/**
 * MemeOfTheDay.jsx — first card on the Home page. One meme per day, same for
 * everyone (the server caches by date). Collapses to nothing if the API errors
 * or the image is dead, so Home never shows a broken card.
 */
import { useState } from 'react';
import { Box, Paper, Typography, Link, Skeleton } from '@mui/material';
import { useMemeOfTheDay } from '../../hooks/useMemeOfTheDay';

const monoSx = { fontFamily: '"DM Mono", monospace' };

export default function MemeOfTheDay() {
  const { data: meme, isLoading, isError } = useMemeOfTheDay();
  const [broken, setBroken] = useState(false);

  if (isError || broken) return null;

  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="overline" color="text.secondary">
          {meme?.slot === 'am' ? 'Morning Motivation' : meme?.slot === 'pm' ? 'Afternoon Cat' : 'Meme of the Day'}
        </Typography>
        {meme?.postLink && (
          <Link href={meme.postLink} target="_blank" rel="noopener noreferrer" underline="hover" variant="caption" color="text.secondary">
            {meme.source === 'xkcd' ? 'xkcd' : meme.subreddit ? `r/${meme.subreddit}` : 'source'}
          </Link>
        )}
      </Box>
      {isLoading ? (
        <Skeleton variant="rounded" height={260} />
      ) : (
        <>
          <Box
            component="img"
            src={meme.url}
            alt={meme.title || 'Meme of the day'}
            title={meme.alt || undefined}
            referrerPolicy="no-referrer"
            onError={() => setBroken(true)}
            sx={{ display: 'block', mx: 'auto', maxWidth: '100%', maxHeight: 420, borderRadius: 1 }}
          />
          {meme.title && (
            <Typography variant="caption" color="text.secondary" sx={{ ...monoSx, display: 'block', textAlign: 'center', mt: 1, fontSize: '0.7rem' }}>
              {meme.title}
            </Typography>
          )}
        </>
      )}
    </Paper>
  );
}
